module.exports = __webpack_public_path__ + "img/raymond_c.71a7030.png";